export default {
      id: "account-balance-usage",
      viewBox: "0 0 32 34",
      url: "/dist/svg/" + "sprite.svg#account-balance-usage",
      toString: function () {
        return this.url;
      }
    }